module.exports = __webpack_public_path__ + "img/noNo.aeaa46e3.jpg";